<div class="generic-modal" (click)="close()" dpadZone="'generic-modal'">
	<div class="generic-modal-box">
		<div class="generic-modal-text-space">
			<div class="generic-modal-header">
				<div class="generic-modal-title">
					{{title}}
				</div>
			</div>
			<div class="generic-modal-body">
				{{text}}
			</div>
		</div>
		<div class="generic-modal-buttons" dpadContainerBasic>
			<button class="btn dpad-start mr-3" dpadSelectable (keyup.enter)="ok()"
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault()" (click)="ok()" *ngIf="okCallback" #okButton>
				{{okLabel}}
			</button>
			<button dpadSelectable class="btn dpad-start" *ngIf="showCloseButton" (blur)="refocus()" #closeButton
				(keyup.enter)="close()" (keydown.enter)="$event.stopPropagation(); $event.preventDefault()" (click)="close()">{{closeLabel}}</button>
		</div>
	</div>
</div>
